<div class="ion-padding">
	<h1 class="align-center">
		{{ 'delivery_not_available_modal.header' | translate }}
	</h1>
	<p>
		{{ 'delivery_not_available_modal.text' | translate }}
	</p>
	<ion-row class="button-container">
		<ion-col (click)="dismiss(action.TAKE_AWAY)" class="action-btn bold pointer">
			{{ 'delivery_not_available_modal.pickup' | translate }}
		</ion-col>
		<ion-col (click)="dismiss(action.DECLINE)" class="action-btn bold negative pointer">
			{{ 'delivery_not_available_modal.cancel' | translate }}
		</ion-col>
	</ion-row>
</div>
